import React from 'react';
import { Check } from 'react-feather';
import { BRAND_COLORS } from '@/UIlibrary/globalTheme';

interface StepIndicatorProps {
	steps: string[];
	currentStep: number;
}

const StepIndicator: React.FC<StepIndicatorProps> = ({ steps, currentStep }) => {
	return (
		<div className="w-full max-w-5xl mx-auto">
			<div className="flex justify-between">
				{steps.map((step, index) => {
					const isCompleted = index < currentStep;
					const isCurrent = index === currentStep;

					return (
						<div key={step} className="flex-1">
							<div className="flex items-center">
								<div className="flex flex-col items-center relative w-full">
									<div className="flex items-center justify-center w-full">
										<div
											style={{
												backgroundColor: isCompleted ? BRAND_COLORS.brand500 : undefined,
												borderColor: isCurrent ? BRAND_COLORS.brand500 : undefined
											}}
											className={`
                        w-8 h-8 rounded-full flex items-center justify-center
                        ${isCompleted ? '' : 'bg-gray-200'}
                        ${isCurrent ? 'border-2 bg-white' : ''}
                        relative z-10
                      `}
										>
											{isCompleted ? (
												<Check className="w-5 h-5 text-white" />
											) : (
												<span
													style={{ color: isCurrent ? BRAND_COLORS.brand500 : undefined }}
													className={`text-sm ${isCurrent ? '' : 'text-gray-600'}`}
												>
													{index + 1}
												</span>
											)}
										</div>

										{index < steps.length - 1 && (
											<div className="absolute w-full h-0.5 top-4 left-1/2">
												<div
													style={{
														backgroundColor: index < currentStep ? BRAND_COLORS.brand500 : undefined
													}}
													className={`h-full ${index < currentStep ? '' : 'bg-gray-200'}`}
												/>
											</div>
										)}
									</div>

									<p
										className={`
                    mt-2 text-sm text-center max-w-20
                    ${isCompleted || isCurrent ? 'text-gray-900' : 'text-gray-500'}
                  `}
									>
										{step}
									</p>
								</div>
							</div>
						</div>
					);
				})}
			</div>
		</div>
	);
};

export default StepIndicator;
